<template>
  <section
    class="relative overflow-hidden rounded-2xl px-7 py-6 bg-gradient-to-br from-[#1c1f26] to-[#181b21] border border-red-500/10 print:border-green-500/80 shadow-[0_0_30px_rgba(239,68,68,0.08)] mt-6"
  >
    <!-- glow decorativo discreto -->
    <div
      class="absolute -top-16 -left-16 w-56 h-56 bg-red-500/10 blur-3xl rounded-full"
    ></div>

    <!-- Header -->
    <div class="relative flex items-center justify-between mb-6">
      <div>
        <h2 class="text-xl font-semibold text-white print:text-black">
          Últimas atualizações
        </h2>
        <p class="text-sm text-gray-400 print:text-black mt-1">
          {{
            recentUpdates?.subtitle || "Últimos setores que responderam o teste"
          }}
        </p>
      </div>

      <div
        class="px-4 py-2 rounded-full text-sm bg-white/5 border border-white/10 text-gray-200 print:text-black"
      >
        Registros:
        <span class="font-semibold">{{ items.length }}</span>
        · Respondentes:
        <span class="font-semibold">{{ totalRespondents }}</span>
      </div>
    </div>

    <div v-if="!items.length" class="text-sm">
      Nenhuma atualização encontrada para os filtros atuais.
    </div>

    <div v-else class="space-y-4">
      <!-- v-for="item in items" -->
      <div class="rounded-2xl p-4 relative overflow-x-auto">
        <table class="min-w-[820px] w-full text-sm">
          <thead class="text-gray-400 print:text-black">
            <tr class="border-b border-white/5">
              <th class="text-left font-medium py-3 pr-4 print:text-black">
                Setor
              </th>
              <th class="text-left font-medium py-3 pr-4 print:text-black">
                Empresa
              </th>
              <th class="text-left font-medium py-3 pr-4 print:text-black">
                Status
              </th>
              <th class="text-center font-medium py-3 print:text-black">
                Participantes
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="item in items"
              :key="`${item.company_id}-${item.role_id}-${item.submitted_at}`"
              class="border-b border-white/5 hover:bg-white/5 transition text-start justify-start"
            >
              <!-- Setor -->
              <td class="py-4 pr-4">
                <div
                  class="text-white print:text-black print:font-semibold font-medium"
                >
                  {{ item.role_name }}
                </div>
              </td>

              <!-- Empresa -->
              <td class="py-4 pr-4">
                <div class="text-gray-200 print:text-black print:font-semibold">
                  {{ item.company_name }}
                </div>
              </td>

              <!-- Status -->
              <td>
                <!-- binário -->
                <div
                  v-if="recentUpdates?.variant === 'binary'"
                  class="min-w-[220px] w-full lg:w-[280px]"
                >
                  <div class="flex justify-between text-xs mb-2">
                    <span>Sim: {{ item.status?.yes_percent ?? 0 }}%</span>
                    <span>Não: {{ item.status?.no_percent ?? 0 }}%</span>
                  </div>

                  <div class="h-3 rounded-full overflow-hidden flex">
                    <div
                      class="h-full bg-emerald-500"
                      :style="{ width: `${item.status?.yes_percent ?? 0}%` }"
                    />
                    <div
                      class="h-full bg-rose-500"
                      :style="{ width: `${item.status?.no_percent ?? 0}%` }"
                    />
                  </div>
                </div>

                <div v-else class="min-w-[220px]">
                  <div
                    class="text-2xl font-bold flex"
                    :class="
                      classificationClass(item.status?.classification?.key)
                    "
                  >
                    <div
                      class="text-xs my-auto pr-1 font-normal text-white print:text-black"
                    >
                      Média:
                    </div>
                    {{ item.status?.display || "0,00" }}
                  </div>
                  <div
                    class="text-sm font-medium flex"
                    :class="
                      classificationClass(item.status?.classification?.key)
                    "
                  >
                    <div
                      class="text-xs my-auto pr-1 text-white print:text-black"
                    >
                      Índice:
                    </div>
                    {{
                      item.status?.classification?.label || "Sem classificação"
                    }}
                  </div>
                </div>
              </td>

              <!-- Participantes -->
              <td class="py-4 text-center">
                <div
                  class="inline-flex items-center gap-2 text-gray-200 print:text-black"
                >
                  <span class="text-lg">👥</span>
                  <span class="font-semibold"
                    >{{ item.respondents_count }} participante(s)</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  responseMode: {
    type: String,
    default: "binary",
  },
  recentUpdates: {
    type: Object,
    default: () => ({
      title: "",
      subtitle: "",
      variant: "binary",
      items: [],
    }),
  },
});

const totalRespondents = computed(() => {
  return items.value.reduce((total, item) => {
    return total + Number(item.respondents_count || 0);
  }, 0);
});

const items = computed(() => props.recentUpdates?.items || []);

const classificationClass = (key) => {
  if (key === "favorable") return "text-emerald-400 print:font-semibold";
  if (key === "risk") return "text-rose-400 print:font-semibold";
  return "text-amber-400 print:font-semibold";
};
</script>
